export enum RoomStateDemoType {
  regular = 1,
  solo = 2,
}

/// define the room state status enum
export enum RoomStateStatus {
  /** active slide has been changed recently and room has not been completed */
  live = 0,

  /** grading was received or students reached the last slide */
  completed = 1,

  /** room was started but not completed, and the assignment expired  */
  abandoned = 2,

  /** room has been scheduled and has not run */
  scheduled = 3,

  /** room has not run and needs a scheduled date */
  mustSchedule = 4,

  /** assignment expired or section closed and room was not started */
  expired = 5,

  /** active slide has **not changed recently**, and room has not been completed */
  suspended = 6,

  /** assignment was cancelled by instructor and room was not completed */
  canceled = 7,

  /** assignment was partially completed and assignment expired
   * room is still within an interval where grading can be kicked off (by a cron)
   */
  queuedForGrading = 8,

  /**
   * same as `suspended`, but its been in this state for more than 2 hours
   * meaning the students should re-schedule the assignment before continuing
   *
   * when in this state roomState property `scheduledAt` should no longer be displayed/used
   */
  mustScheduleSuspended = 9,
}
